export enum ModalTypes {
    OPEN_MODAL = '[auth] OPEN_MODAL',
    CLOSE_MODAL = '[auth] CLOSE_MODAL',
    REACTIVE_COL = '[auth] REACTIVE_COL',
};